import React from 'react';
import { Descriptions, Spin, Typography, Tag } from 'antd';
import Drawer from '../../../../components/AppDrawer';
import type { CustomerSegmentDetail } from '../types';
import AuditProperties from '../../../../components/AuditProperties';

const { Text } = Typography;

export interface CustomerSegmentViewDrawerProps {
  open: boolean;
  onClose: () => void;
  customerSegment: CustomerSegmentDetail | null | undefined;
  loading: boolean;
  onEdit: () => void;
}

const CustomerSegmentViewDrawer: React.FC<CustomerSegmentViewDrawerProps> = ({
  open,
  onClose,
  customerSegment,
  loading,
  onEdit,
}) => {

  return (
    <Drawer
      title="Customer segment details"
      placement="right"
      size="large"
      open={open}
      onClose={onClose}
      extra={
        <Typography.Link onClick={onEdit} style={{ marginRight: 8 }}>
          Edit
        </Typography.Link>
      }
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: 24 }}>
          <Spin />
        </div>
      ) : customerSegment === null || customerSegment === undefined ? (
        <Text type="secondary">Segment not found.</Text>
      ) : (
        <>
          <div className="cp-form-section">
            <Descriptions column={2} size="small" title="Basic information">
              <Descriptions.Item label="Title" span={2}>
                <Text strong>{customerSegment.title}</Text>
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                {customerSegment.isActive ? (
                  <Tag color="green">Active</Tag>
                ) : (
                  <Tag color="default">Inactive</Tag>
                )}
              </Descriptions.Item>
            </Descriptions>
          </div>

          {customerSegment.description && (
            <div className="cp-form-section">
              <Text strong>Description</Text>
              <div style={{ marginTop: 4 }}>
                <Text type="secondary">{customerSegment.description}</Text>
              </div>
            </div>
          )}

          <AuditProperties
            className="cp-form-section"
            values={{
              createdAtUtc: customerSegment.createdAtUtc,
              createdByDisplayName: customerSegment.createdByDisplayName,
              createdByUserId: customerSegment.createdByUserId,
              lastModifiedAtUtc: customerSegment.lastModifiedAtUtc,
              modifiedByDisplayName: customerSegment.modifiedByDisplayName,
              modifiedByUserId: customerSegment.modifiedByUserId,
            }}
          />
        </>
      )}
    </Drawer>
  );
};

export default CustomerSegmentViewDrawer;
